import { render, staticRenderFns } from "./BurntestModal.vue?vue&type=template&id=5ccfdf98"
import script from "./BurntestModal.vue?vue&type=script&lang=js"
export * from "./BurntestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports